module.exports = __webpack_public_path__ + "img/clock.290a7d7a.svg";